"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_c958c9a3{position:relative;padding:5px 38px}.root_c958c9a3 .ms-Link{font-size:12px}\n" }]);
exports.root = "root_c958c9a3";
//# sourceMappingURL=GroupFooter.scss.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/GroupedList/GroupFooter.scss.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/GroupedList/GroupFooter.scss.js
// module chunks = 1